import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import pimg1 from '../../images/brand/logo (1).png'
import pimg2 from '../../images/brand/logo (2).png'
import pimg3 from '../../images/brand/logo (3).png'
import pimg4 from '../../images/brand/crop-festival.png'
import pimg5 from '../../images/brand/lordofthemics (2).jpg'
import pimg6 from '../../images/brand/brand-logo06.png'
import pimg7 from '../../images/brand/brand-logo05.png'

const partners = [
    {
        pImg: pimg1,
        href: "https://iceskateleicester.co.uk"
    },
    {
        pImg: pimg2,
        href: "https://txtsync.com"
    },
    {
        pImg: pimg3,
        href: "https://themirage.events"
    }, {
        pImg: pimg4,
        href: "https://festivals2go.co.uk"
    }, {
        pImg: pimg5,
        href: "https://lordofthemics.com"
    }
]

var settings = {
    dots: false,
    infinite: true,
    speed: 5000,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: "linear",
    arrows: false, 
};



const PartnerSection = (props) => {

    return (
        <section className="brand pt-30 pb-60">
            <div className="container">
                <div className="o-hidden">
                    <div className="brand-sub_title">
                        <span>Processing so seamless that is has been trusted by over <b>42,000</b> people</span>
                    </div>
                    <div className="brand-wrap brand-marquee">
                        <Slider {...settings}>
                            {partners.map((partner, pitem) => (
                                <a href={partner.href} className="brand-logo" key={pitem}>
                                    <img src={partner.pImg} alt="Client Logo" style={{
                                        maxHeight: 120
                                    }} />
                                </a>
                            ))}
                        </Slider>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default PartnerSection;